import { SearchInput } from "../../filters/ui/SearchInput";

import { useSeoAlertsFilterStore } from "./useSeoAlertsFilterStore";

export const Search = () => {
    const searchValue = useSeoAlertsFilterStore((state) => state.searchValue);
    const setSearchValue = useSeoAlertsFilterStore((state) => state.setSearchValue);

    return (
        <SearchInput
            value={searchValue}
            onChange={setSearchValue}
        />
    );
};
